<template>
    <div>

        <div class="container position-relative" :class="isDark ? '' : 'bg-light'" style="top: -50px">

            <div class="row">

                <div class="col-md-9 mx-auto p-2">

                    <div class="row justify-content-between align-items-center mb-5 px-4">
                        <div id="qr" data-target="#qr_modal"></div>
                        <img :src="currentLogo" alt="paystar logo" height="60">
                    </div>


                    <div class="row mb-5 p-4">
                        <div class="card w-100 bg-white p-3">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class=" d-flex d-inline mx-4 mt-2">
                                        <div class="mr-1 mt-3">
                                            <p class="h6 text-secondary">پرداخت کننده</p>
                                            <p class="h5">{{ info.origin_user }}</p>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <hr>

                            <div class="row m-4">
                                <div class="col-md-4 p-2">
                                    <div class="border border-secondary rounded-lg h-100 p-2"
                                         :style="isDark ? '' : 'border-color: rgba(0,0,0,.1) !important;'">
                                        <p class="text-secondary">تعداد تراکنش ها</p>
                                        <p class="text-center">{{ info.tr_count }} تراکنش</p>
                                    </div>
                                </div>
                                <div class="col-md-4 p-2">
                                    <div class="border border-secondary rounded-lg h-100 p-2"
                                         :style="isDark ? '' : 'border-color: rgba(0,0,0,.1) !important;'">
                                        <p class="text-secondary">شناسه تراکنش گروهی</p>
                                        <p class="text-center">{{ hashid }}</p>
                                    </div>
                                </div>
                                <div class="col-md-4 p-2">
                                    <div class="border border-secondary rounded-lg h-100 p-2"
                                         :style="isDark ? '' : 'border-color: rgba(0,0,0,.1) !important;'">
                                        <p class="text-secondary">مبلغ کل </p>
                                        <p class="text-center">{{ info.tr_sum_amount }} ریال</p>
                                    </div>
                                </div>
                                <div class="col-md-4 p-2">
                                    <div class="border border-secondary rounded-lg h-100 p-2"
                                         :style="isDark ? '' : 'border-color: rgba(0,0,0,.1) !important;'">
                                        <p class="text-secondary">مبلغ تسویه شده موفق</p>
                                        <p class="text-center">{{ info.tr_sum_success_amount }} ریال</p>
                                    </div>
                                </div>
                                <div class="col-md-4 p-2">
                                    <div class="border border-secondary rounded-lg h-100 p-2"
                                         :style="isDark ? '' : 'border-color: rgba(0,0,0,.1) !important;'">
                                        <p class="text-secondary">حساب مقصد</p>
                                        <p class="text-center">{{ info.destination_firstname }}
                                            {{ info.destination_lastname }}</p>
                                    </div>
                                </div>
                                <div class="col-md-4 p-2">
                                    <div class="border border-secondary rounded-lg h-100 p-2"
                                         :style="isDark ? '' : 'border-color: rgba(0,0,0,.1) !important;'">
                                        <p class="text-secondary">شماره شبا</p>
                                        <p class="text-center">{{ info.destination_number }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-for="(fetchReceipt, index) in fetchReceipts" :key="index" class="card  p-3 bg-white mb-5"
                         :class="isDark ? 'wallet_receipt_card_dark': 'wallet_receipt_card'">
                        <!-- Transaction Status -->
                        <div v-if="fetchReceipt !== null">
                            <div v-if="isSuccess(fetchReceipt)" class="rowBox d-flex align-items-center mt-4">
                                <p class="rowNum"></p>
                                <div class="statusBox"><p class="status m-0 text-dark pr-3" style="font-size: 15px">
                                    انتقال وجه <b>{{ fetchReceipt.settlement_type }}</b> با موفقیت انجام شد.
                                </p></div>
                                <div class="checkBox"><i class="far fa-check-circle fa-3x text-white"></i></div>
                            </div>
                            <div v-else-if="fetchReceipt.status === walletTransactionStatus.PENDING ||
                                fetchReceipt.status === walletTransactionStatus.CHARGE_PENDING ||
                                fetchReceipt.status === walletTransactionStatus.UNKNOWN_YET ||
                                fetchReceipt.status === walletTransactionStatus.SETTLEMENT_PENDING ||
                                fetchReceipt.status === walletTransactionStatus.CREATED"
                                 class="rowBox d-flex align-items-center mt-4 bg-warning">
                                <p class="rowNum"></p>
                                <div class="statusBox">
                                    <p class="status m-0" style="font-size: 15px"> {{ $t('wallets.receipt.pending_payment') }} </p>
                                </div>
                                <div class="checkBox"><i class="far fa-x fa-3x text-white"></i></div>
                            </div>
                          <div v-else class="rowBox d-flex align-items-center mt-4 bg-danger">
                                <p class="rowNum"></p>
                                <div class="statusBox">
                                    <p class="status m-0" style="font-size: 15px"> {{ $t('wallets.receipt.fail_payment') }} </p>
                                </div>
                                <div class="checkBox"><i class="far fa-x fa-3x text-white"></i></div>
                            </div>
                        </div>
                        <!-- Transfer -->
                        <div v-else>
                            <div class="text-center my-2" v-if="fetchTransfer.status === 2">
                                <i class="far fa-check-circle fa-3x text-success"></i>
                            </div>
                            <div v-else class="text-center my-2">
                                <i class="fas fa-exclamation-triangle fa-3x text-danger"></i>
                            </div>
                            <div
                                class="w-100 text-center d-flex align-items-center justify-content-center my-2"
                            >
                                <div
                                    v-if="fetchTransfer.status === 2"
                                    class="card bg-success text-white p-3 w-50 my-1"
                                >
                                    {{ $t('wallets.receipt.success_payment') }}
                                </div>
                                <div v-else class="card bg-danger text-white p-3 w-50 my-1">
                                    {{ $t('wallets.receipt.fail_payment') }}
                                </div>
                            </div>
                        </div>
                        <!-- Details Settlement -->
                        <div class="details text-center py-3" v-if="fetchReceipt !== null">
                            <!--            <div class="h5 mb-4">{{ $t('wallets.receipt.description') }}</div>-->
                            <div class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">ردیف</span>
                                <div class="dashed bg-white"></div>
                                <span class="mx-2" v-if="fetchReceipt.settlement_data">{{
                                        index +1
                                    }}</span>
                            </div>

                            <div class="d-flex flex-row justify-content-between my-4 align-items-center">
                              <span class="mx-2 font-weight-bold">{{ $t('label.hashid') }}</span>
                              <div class="dashed"></div>
                              <span class="mx-2">{{ fetchReceipt.hashid }}</span>
                            </div>

                            <div class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">{{ $t('wallets.receipt.price') }}</span>
                                <div class="dashed bg-white"></div>
                                <span class="mx-2" v-if="fetchReceipt.settlement_data">{{
                                        Number(fetchReceipt.settlement_data.amount).toLocaleString() +
                                        " " +
                                        "ریال"
                                    }}</span>
                            </div>


                            <div v-if="fetchReceipt.settlement_data.payment_id"
                                 class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">{{ $t('wallets.label.payment_id') }}</span>
                                <div class="dashed"></div>
                                <span class="mx-2">{{ fetchReceipt.settlement_data.payment_id }}</span>
                            </div>
                            <div v-if="isSuccess(fetchReceipt)"
                                 class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">{{ $t('wallets.receipt.ref_code') }}</span>
                                <div class="dashed"></div>
                                <span class="mx-2">{{ fetchReceipt.ref_code }}</span>
                            </div>
                            <div v-if="isSuccess(fetchReceipt)"
                                 class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">{{ $t('wallets.receipt.create_at') }}</span>
                                <div class="dashed"></div>
                                <span class="mx-2" style="direction: ltr">{{ fetchReceipt.created_at }}</span>
                            </div>
                            <div v-if="isSuccess(fetchReceipt)"
                                 class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">{{ $t('wallets.receipt.payment_date') }}</span>
                                <div class="dashed"></div>
                                <span class="mx-2" style="direction: ltr">{{ fetchReceipt.payment_date }}</span>
                            </div>
                            <div v-if="isSuccess(fetchReceipt)"
                                 class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">{{ $t('wallets.receipt.bank') }}</span>
                                <div class="dashed"></div>
                                <span class="mx-2">
                {{ bankIdStr.get(fetchReceipt.origin_bank) }}
                به
                {{ bankIdStr.get(fetchReceipt.destination_bank) }}
              </span>
                            </div>
                        </div>
                        <!-- Details Transfer -->
                        <div class="text-center py-3" v-else>
                            <div class="h5 mb-4">{{ $t('wallets.receipt.description') }}</div>
                            <div class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">{{ $t('wallets.receipt.price') }}</span>
                                <div class="dashed"></div>
                                <span class="mx-2">{{
                                        Number(fetchTransfer.amount).toLocaleString() + " " + "ریال"
                                    }}</span>
                            </div>
                            <div class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">{{ $t('wallets.receipt.wallet_id_to') }}</span>
                                <div class="dashed"></div>
                                <span class="mx-2">{{ fetchTransfer.from.wallet_id }}</span>
                            </div>
                            <div class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">{{ $t('wallets.receipt.wallet_id_from') }}</span>
                                <div class="dashed"></div>
                                <span class="mx-2">{{ fetchTransfer.to.wallet_id }}</span>
                            </div>
                            <div
                                v-if="fetchTransfer.from.user !== null"
                                class="d-flex flex-row justify-content-between my-4 align-items-center"
                            >
                                <span class="mx-2 font-weight-bold">{{ $t('wallets.receipt.user_to') }}</span>
                                <div class="dashed"></div>
                                <span class="mx-2">{{ fetchTransfer.from.user }}</span>
                            </div>
                            <div
                                v-if="fetchTransfer.to.user !== null"
                                class="d-flex flex-row justify-content-between my-4 align-items-center"
                            >
                                <span class="mx-2 font-weight-bold">{{ $t('wallets.receipt.user_from') }}</span>
                                <div class="dashed"></div>
                                <span class="mx-2">{{ fetchTransfer.to.user }}</span>
                            </div>
                            <div v-if="fetchTransfer.status === 2"
                                 class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">تاریخ ایجاد</span>
                                <div class="dashed bg-white"></div>
                                <span class="mx-2" style="direction: ltr">{{
                                        toPersianDateFormat(fetchTransfer.created_at)
                                    }}</span>
                            </div>
                            <div
                                v-if="fetchTransfer.transfer_description != '' && fetchTransfer.transfer_description != null"
                                class="d-flex flex-row justify-content-between my-4 align-items-center">
                                <span class="mx-2 font-weight-bold">توضیحات</span>
                                <div class="dashed"></div>
                                <span class="mx-2">{{ fetchTransfer.transfer_description }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 py-5 mt-5">
                        <div class="text-center font-weight-bold">
                            راه های ارتباطی با پشتیبانی شرکت پی استار
                        </div>
                        <div class="d-flex justify-content-between pt-4">
                            <div>
                                <a href="tel:+9802191300818" target="_blank" class="text-decoration-none " dir="ltr">021
                                    91 300 818</a>
                                <span style="padding: 0 10px;">
                <i class="fa fa-phone"></i>
              </span>
                            </div>
                            <div>
                                <a href="https://paystar.ir" target="_blank" class="text-decoration-none " dir="ltr">www.paystar.ir</a>
                                <span style="padding: 0 10px;">
                <i class="fa fa-globe"></i>
              </span>
                            </div>
                            <div>
                                <a href="mailto:info@paystar.ir" class="text-decoration-none"
                                   dir="ltr">info@paystar.ir</a>
                                <span style="padding: 0 10px;">
                <i class="fa fa-envelope"></i>
              </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {bankIdStr} from "@/constants/bankId";
import QrCodeWithLogo from "qr-code-with-logo";
import {walletService} from "@/common/api.service";
import {walletTransactionStatus} from "@/constants/walletTransactionStatus";
import $ from "jquery";

export default {
    name: "WalletSettlementCollectionReceipt",
    props: ['hashid'],
    data() {
        return {
            bankIdStr,
            fetchReceipts: null,
            fetchTransfer: {},
            info: {},
            currentTheme: 'dark'
        };
    },
    methods: {
        createQrCode() {
            setTimeout(() => {
                let qr_canvas = document.createElement('canvas');
                qr_canvas.style.cursor = 'pointer';
                document.getElementById('qr').appendChild(qr_canvas);
                QrCodeWithLogo.toCanvas({
                    canvas: qr_canvas,
                    content: window.location.href,
                    width: 100,
                    height: 100,
                    logo: {
                        src: "/favicon_new_dark.png",
                        borderRadius: '50',
                        bgColor: '#fff',
                        logoSize: 0.25,
                        borderSize: 0
                    }
                })
            }, 5);
        },
        isSuccess(transaction) {
            if (transaction)
                return ((transaction.status === walletTransactionStatus.SUCCESS || transaction.status === walletTransactionStatus.SUCCESS_UPCOMING)  && transaction.charge_rev_id === '');
        },
        toPersianDateFormat(val) {
            if (val === undefined || val === null || val === "") {
                return "";
            }

            val = String(val);

            return val.replace(/\-/g, "/");
        },
        updateTheme() {
            this.currentTheme = window.localStorage.getItem('AppUiTheme') || 'light';
        },
        setupThemeListener() {
            window.addEventListener('storage', (e) => {
                if (e.key === 'AppUiTheme') {
                    this.updateTheme();
                }
            });

            window.addEventListener('themeChanged', () => {
                this.updateTheme();
            });

            this.themeCheckInterval = setInterval(() => {
                const newTheme = window.localStorage.getItem('AppUiTheme') || 'light';
                if (newTheme !== this.currentTheme) {
                    this.currentTheme = newTheme;
                }
            }, 100);
        }
    },
    async mounted() {
      $('#formaloo').hide()
      await walletService.fetchWalletSettlementCollectionReceipt(this.hashid)
            .then((response) => {
                this.info = response.data.data
                this.fetchReceipts = this.info.transaction;


            })
            .catch((error) => {
                throw new Error(error)
            });
        this.createQrCode()
        
        this.updateTheme();
        this.setupThemeListener();
    },
    beforeDestroy() {
        if (this.themeCheckInterval) {
            clearInterval(this.themeCheckInterval);
        }
        window.removeEventListener('storage', this.updateTheme);
        window.removeEventListener('themeChanged', this.updateTheme);
    },

    computed: {
        walletTransactionStatus() {
            return walletTransactionStatus
        },
        isDark() {
            return this.currentTheme === 'dark';
        },
        currentLogo() {
            return this.currentTheme === 'dark' 
                ? '/assets/logo_new_light.png'
                : '/assets/logo_new_dark.png';
        }
    }
}
</script>

<style scoped>
.img-sm-size {
    width: 150px;
    height: 80px;
}

.font-awesome-icon-size {
    font-size: 50px;
}

.bg-recepit {
    background-color: #1e272e;
}

.alert-recepit {
    background-color: #0be881;
}

.color-recepit {
    color: #0be881;
}

.wallet_receipt_card:after {
    width: 100%;
    content: "";
    display: block;
    position: absolute;
    bottom: -9px;
    left: 0;
    transform: rotate(-180deg);
    height: 10px;
    background: linear-gradient(45deg, transparent 33.333%, #fff 33.333%, #fff 66.667%, transparent 66.667%), linear-gradient(-45deg, transparent 33.333%, #fff 33.333%, #fff 66.667%, transparent 66.667%);
    background-size: 20px 40px;
}


.wallet_receipt_card_dark:after {
    width: 100%;
    content: "";
    display: block;
    position: absolute;
    bottom: -9px;
    left: 0;
    transform: rotate(-180deg);
    height: 10px;
    background: linear-gradient(45deg, transparent 33.333%, #333 33.333%, #333 66.667%, transparent 66.667%), linear-gradient(-45deg, transparent 33.333%, #333 33.333%, #333 66.667%, transparent 66.667%);
    background-size: 20px 40px;
}

@media screen and (max-width: 678px) {
    .bg-recepit {
        font-size: 9px;
    }
}

.card {
    border-radius: 10px 10px 0 0 !important;
}

.dashed {
    flex: 1;
    height: 1px;
    border-top: 1px dashed;
    margin-left: 10px;
    margin-right: 10px;
    opacity: 0.2;
}

.details {
    font-size: 14px;
}

.rowBox {
    width: calc(100% - 15px);
    background: #0be881;
    border-radius: 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    position: relative;
}

</style>
